<main
    @slideX
    class="safe-top safe-bottom absolute z-[9999] top-0 right-0 min-w-[300px] sm:min-w-[480px] h-screen bg-white flex flex-col overflow-y-scroll"
>
    <div class="flex flex-col justify-between h-full">
        <div class="flex flex-col gap-4 h-full">
            <div class="flex justify-end p-4 pb-2 w-full">
                <app-icon
                    (click)="close()"
                    class="text-gray-500 cursor-pointer"
                    name="material-symbols:close-rounded"
                    size="lg"
                />
            </div>

            <div class="flex flex-col gap-4 px-6">
                <div class="flex justify-between items-center">
                    @if (user(); as user) {
                        <div class="flex flex-col gap-2 *:break-all">
                            <p class="font-bold text-gray-800 md:text-lg">
                                {{ user?.name || user.auths[0].email }} 님
                            </p>
                            <p class="text-xs text-gray-400 md:text-sm">
                                {{ user.auths[0].email }}
                            </p>
                        </div>
                    }
                    <app-icon
                        name="material-symbols:arrow-forward-ios"
                        class="text-gray-300 cursor-pointer"
                        size="sm"
                    />
                </div>

                <div class="flex items-center gap-2.5">
                    @for (menu of mainMenus(); track $index) {
                        <button
                            (click)="menu.click()"
                            class="flex flex-col items-center justify-center flex-1 h-full gap-1 cursor-pointer min-h-14"
                        >
                            <app-icon
                                [name]="menu.icon"
                                class="text-gray-500"
                            />
                            <p
                                class="text-xs font-semibold text-center text-gray-500"
                                routerLinkActive="text-primary"
                            >
                                {{ menu.title }}
                            </p>
                        </button>
                    }
                </div>
                <!-- 메뉴 -->
                <div
                    class="flex flex-col justify-center border-t border-gray-100"
                >
                    @for (menu of menus; track $index) {
                        <button
                            class="flex justify-between items-center py-3 w-full"
                            [routerLink]="menu.link"
                            [queryParams]="menu?.queryParams"
                            (click)="close()"
                        >
                            <div class="flex gap-3 items-center w-full">
                                <app-icon
                                    [name]="menu.iconName"
                                    class="text-gray-500"
                                />
                                <p
                                    class="text-sm font-semibold text-gray-800 md:text-base"
                                >
                                    {{ menu.title }}
                                    @if (!!menu?.count) {
                                        <span>({{ menu.count }})</span>
                                    }
                                </p>
                            </div>
                            <app-icon
                                name="material-symbols:arrow-forward-ios"
                                class="text-gray-400 size-3"
                                size="xs"
                            />
                        </button>
                        @if (!$last) {
                            <div class="w-full h-px bg-gray-100"></div>
                        }
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="px-6 pb-6 w-full">
        <button
            (click)="logout($event)"
            class="flex justify-between items-center w-full"
        >
            <div class="flex gap-3 items-center">
                <div class="flex justify-center items-center size-8">
                    <app-icon
                        name="solar:logout-2-bold-duotone"
                        class="!size-5 text-gray-500"
                    />
                </div>
                <p class="text-gray-400">로그아웃</p>
            </div>
            <app-icon name="mdi:chevron-right" class="text-gray-400" />
        </button>
    </div>
</main>
